import jwtAuthAxios from "./auth/jwtAuth";

const warehouseBinServices = {};

// El tablero completo de una bodega en una sola llamada: bins + bounds + summary.
// No pagina a propósito — dibujar medio plano no sirve de nada.
warehouseBinServices.getLayout = async (centreId) => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins/layout?centre_id=${centreId}`);
    return data;
};

warehouseBinServices.getBins = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins${params}`);
    return data;
};

warehouseBinServices.getBin = async (id) => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins/${id}`);
    return data;
};

warehouseBinServices.createBin = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins`, { warehouse_bin: payload });
    return data;
};

warehouseBinServices.updateBin = async (id, payload) => {
    const { data } = await jwtAuthAxios.patch(`/warehouse_bins/${id}`, { warehouse_bin: payload });
    return data;
};

warehouseBinServices.deleteBin = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/warehouse_bins/${id}`);
    return data;
};

// Genera un pasillo completo: N racks × M niveles × P posiciones.
warehouseBinServices.generateAisle = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/generate_aisle`, payload);
    return data;
};

// Guarda las coordenadas tras mover racks en el plano. Manda solo lo movido.
warehouseBinServices.bulkLayout = async (centreId, bins) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/bulk_layout`, {
        centre_id: centreId,
        bins,
    });
    return data;
};

warehouseBinServices.resequence = async (centreId) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/resequence`, { centre_id: centreId });
    return data;
};

warehouseBinServices.assignSku = async (binId, payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/${binId}/assign_sku`, payload);
    return data;
};

warehouseBinServices.unassignSku = async (binId, skuId) => {
    const { data } = await jwtAuthAxios.delete(`/warehouse_bins/${binId}/unassign_sku?sku_id=${skuId}`);
    return data;
};

// Suelta un rack de un tipo dado en una celda del plano. Crea las posiciones con
// sus códigos y devuelve dónde quedó (pasillo y rack asignados).
warehouseBinServices.placeRack = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/place_rack`, payload);
    return data;
};

// Devuelve el ZPL de las etiquetas de rack, para mandarlo a la Zebra por QZ Tray.
warehouseBinServices.getLabels = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins/labels${params}`);
    return data;
};

warehouseBinServices.exportBins = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins/export${params}`, {
        responseType: "arraybuffer",
    });
    return data;
};

warehouseBinServices.downloadTemplate = async () => {
    const { data } = await jwtAuthAxios.get(`/warehouse_bins/download_template`, {
        responseType: "arraybuffer",
    });
    return data;
};

warehouseBinServices.importBins = async (centreId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("centre_id", centreId);

    const { data } = await jwtAuthAxios.post(`/warehouse_bins/import`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

// Borra varias posiciones de una vez: un rack completo o un pasillo entero.
// Borrarlas de a una no sirve cuando un pasillo generado son 40 o más.
warehouseBinServices.bulkDestroy = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_bins/bulk_destroy`, payload);
    return data;
};

export default warehouseBinServices;
